import { capitalizeFirstLetter, formatAsUSD } from './index';
export const getInvalidCostErrorMessage = (subProgramLabel) => `${capitalizeFirstLetter(subProgramLabel)} cost is not a valid value.`;
/**
 * Retrieves cost of division, which is an optional registration setting
 * for a given Division.
 * @param division The division to get the cost from.
 * @returns The cost of the division, defaulting to 0 if no cost is specified.
 */
export const getDivisionCost = (division) => {
    const cost = division.cost ? Number(division.cost) : 0;
    if (isNaN(cost)) {
        throw new Error(`${capitalizeFirstLetter(division.subProgramLabel)} cost is not a valid value.`);
    }
    return cost;
};
const formatAsUSDWithoutZeroCents = (value) => {
    return formatAsUSD(value, { hideZeroCents: true });
};
/**
 * Formats cost with min and max. If max is equal to min, return only
 * a single formatted value.
 */
export const formatCostRange = (min, max) => {
    const minValue = Number(min);
    const maxValue = Number(max);
    if (isNaN(minValue) || isNaN(maxValue)) {
        throw new Error('Value provided is not a number');
    }
    if (minValue === maxValue) {
        return formatAsUSDWithoutZeroCents(minValue);
    }
    return `${formatAsUSDWithoutZeroCents(minValue)} - ${formatAsUSDWithoutZeroCents(maxValue)}`;
};
export const isFree = (max) => {
    const maxValue = Number(max);
    if (isNaN(maxValue)) {
        throw new Error('Value provided is not a number.');
    }
    return maxValue === 0;
};
export const formatPriceAdjustment = (amount) => {
    return `${amount < 0 ? '-' : '+'} ${formatAsUSD(Math.abs(amount), { hideZeroCents: false })}`;
};
/**
 * Gets mapping of team price adjustment amounts grouped by program and team
 * @param divisions Divisions to get the price adjustments for
 * @param divisionCardsState State of division during registration
 * @param teams Teams to include. Only teams that are saved will be included in the
 * total price adjustment amount.
 * @returns The team price adjustments mapping and the total price adjustment amount
 */
export const getTeamPriceAdjustmentsMapAndAmounts = (divisions, divisionCardsState, teams) => {
    const teamPriceAdjustments = {};
    let totalPriceAdjustmentAmount = 0;
    divisions.forEach(({ id, pricingOption }) => {
        if (pricingOption) {
            const divisionCardState = divisionCardsState[id];
            const savedTeamIds = [];
            if (divisionCardState.value === 'saved' ||
                divisionCardState.value === 'saved-and-editing') {
                savedTeamIds.push(...divisionCardState.savedTeams);
            }
            teams.forEach((team) => {
                var _a, _b, _c, _d;
                if (team.formFields) {
                    const formField = team.formFields.find((field) => field.formFieldId === pricingOption.formFieldId);
                    if (formField && ((_a = formField.values) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                        const itemId = parseInt((_c = (_b = formField.values[0]) === null || _b === void 0 ? void 0 : _b.toString()) !== null && _c !== void 0 ? _c : '');
                        const option = (_d = pricingOption.pricingOptions) === null || _d === void 0 ? void 0 : _d.find((option) => option.itemId === itemId);
                        if (option) {
                            const amount = parseFloat(option.priceAdjustmentAmount);
                            if (savedTeamIds.includes(team.id)) {
                                totalPriceAdjustmentAmount += amount;
                            }
                            teamPriceAdjustments[id] = Object.assign(Object.assign({}, teamPriceAdjustments[id]), { [team.id]: amount });
                        }
                    }
                }
            });
        }
    });
    return {
        teamPriceAdjustments,
        totalPriceAdjustmentAmount,
    };
};
